export default __webpack_public_path__ + "static/22-bfdabd6870514d45b04db4cdb40d90f7.jpg";